import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-draw-disable.png'

const DrawDisableBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default DrawDisableBtn
